import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { WebSiteConfig } from './ubs-config-model';
import { of as observableOf,Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
//import { select, Store } from '@ngrx/store';
//import { retrieveEnv, retrieveWebSiteConfig } from './usb-configuration-actions';
//import { selectWebConfig,selectEnv } from './ubs-configuration.selectors';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  baseUrl:string;

  private webSiteConfigSubject = new BehaviorSubject<WebSiteConfig | null>(null);
  public webSiteConfig$ = this.webSiteConfigSubject.asObservable();
  private tenantSubject = new BehaviorSubject<any | null>(null);
  public tenant$ = this.tenantSubject.asObservable();
  
  constructor(@Inject(PLATFORM_ID) private platformId: string,
  private injector: Injector,
  private http: HttpClient,
  //private store: Store
  ) { }

  setSiteConfig(env):void{
    console.log(env);
    let hostName:string = "";
    console.log(env);
    this.baseUrl = env.apiUrl+"/";
    //this.store.dispatch(retrieveEnv({env}));
    if(isPlatformBrowser(this.platformId)){
      hostName = window.location.host;
      if(hostName.includes(":")){
        hostName = hostName.substring(0,hostName.indexOf(":"));
      }
      if(env.apiUrl){
        this.getWebSiteConfig(hostName,env)
        .subscribe((webSiteConfig:WebSiteConfig) => {
          this.webSiteConfigSubject.next(webSiteConfig);
          console.log({Result:webSiteConfig});
          //this.store.dispatch(retrieveWebSiteConfig({webSiteConfig}))
          //this.storeCheck();
        });
      }
    }else{
      const requestUrl = this.injector.get('requestUrl');    // 3. ..retrieve the injected url
      console.log('server greets you via ' + requestUrl)
    }
    
  }

  getWebSiteConfig(hostName:string,env):Observable<WebSiteConfig>{
    this.baseUrl = env.apiUrl+"/";
    //console.log(this.baseUrl);
    let url:string = this.baseUrl+'widgets/form/value/SiteConfiguration?location=component://kwikstore/widget/SetupForms.xml&hostName='+hostName;
    return this.http.get<WebSiteConfig>(url)
    .pipe(
      map(resp => resp)
    )
  }

  /* storeCheck(){
    this.store.pipe(select(selectWebConfig)).subscribe(data => console.log({StoreCheck:data}));
  } */

  /* selectWebSiteConfig():Observable<WebSiteConfig>{
    return this.store.pipe(select(selectWebConfig));
  } */

  /* selectEnv(){
    let env:any = null;
    this.store.pipe(select(selectEnv))
    .subscribe(data => {
      env = data;
    });
    return env;
  } */

  getBaseUrl(){
    return this.baseUrl;
  }
}
function observerbleOf(webSiteConfig: WebSiteConfig): Observable<WebSiteConfig> {
  throw new Error('Function not implemented.');
}

